import { Component, Input, OnInit } from "@angular/core";
import { ResumeService } from "../../../resume/resume.service";
import { ActualSelected } from "../../../../shared/utils";

@Component({
    selector: 'report-ratio',
    templateUrl: './report-ratio.component.html',
    styleUrls: ['../../accounting-tabs.component.scss'],
    standalone: false
})

export class ReportRatioComponent implements OnInit {
  @Input()
  showGlobal: boolean = false;

  resumeloading = false;
  summaryResult: any;

  yearSelected: string;

  constructor(
    private resumeService: ResumeService,
  ) {
  }

  ngOnInit() {
    this.getData();
    // console.log('ActualSelected', ActualSelected)
    this.yearSelected = ActualSelected.yearSelected;
  }

  getData() {
    this.resumeService.getReportWorkingCapital().then(response => {
      this.summaryResult = response;
      this.resumeloading = true;
    });
  }

  getPositivePercentage(num1, num2) {
    const ratio = num1 / num2;
    return Math.abs(ratio); // Usa Math.abs para garantizar un valor positivo
  }
}
